export const paths = {
  index: '/',
  post: '/post',
  calendar: '/calendar',
  documents: '/documents',
  chat: '/chat',
  wiki: '/wiki',
  account: '/account',
  company: {
    user: '/company',
    admin: '/company/edit',
    member: '/company/member'
  },
  content: {
    create: '/content/create',
    edit: '/content/edit',
    drafts: '/content/drafts',
    planned: '/content/planned',
    published: '/content/published',
    results: '/content/results'
  },
  newsletter: {
    create: '/newsletter/create',
    edit: '/newsletter/edit',
    drafts: '/newsletter/drafts',
    planned: '/newsletter/planned',
    published: '/newsletter/published',
    results: '/newsletter/results'
  },
  occasion: {
    create: '/occasion/create',
    edit: '/occasion/edit',
    drafts: '/occasion/drafts',
    planned: '/occasion/planned',
    published: '/occasion/published',
    results: '/occasion/results'
  },
  admin: {
    manage: {
      index: '/admin/manage',
      group: '/admin/manage/group',
      company: '/admin/manage/company',
      member: '/admin/manage/member',
      list: '/admin/manage/list',
      surveyTemplate: '/admin/manage/survey-template'
    },
    settings: {
      index: '/admin/settings',
      signature: '/admin/settings/signature',
      // TODO: rename to email-template
      template: '/admin/settings/template'
    }
  },
  auth: {
    firebase: {
      start: '/auth/start',
      create: '/auth/create',
      reset: '/auth/reset',
      login: '/auth/login',
      recover: '/auth/recover'
    },
    apiKey: {
      login: '/master-login'
    }
  },
  terms: '/terms',
  privacy: '/privacy',
  401: '/401',
  404: '/404',
  500: '/500'
};
